import React from "react";
import "../assets/styles/home.css";

export const LoaderLinearDots = () => {
  return (
    <div className="balls">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
